import * as React from "react";
import { Component } from "react";

import { NavigationConfiguration } from "../../config/navigation-configuration";
import { UiState } from "../../core/ui-state";
import SVG from "react-inlinesvg";
import crossIcon from "../../assets/images/layout/cross.svg";
import { NavLink } from "react-router-dom";
import "./navigation.scss";

export interface MobileNavigationProps {
    config: NavigationConfiguration;
    uiStore: UiState;
}

export class MobileNavigation extends Component<MobileNavigationProps, any> {
    uiStore: UiState;

    constructor(props: MobileNavigationProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }

    setSidebarVisible(sidebarVisible: boolean): void {
        this.uiStore.setSidebarVisible(sidebarVisible);
    }

    render(): JSX.Element | null {
        return (
            <div id="mobileNav" className="mobilenavigation">
                <div className="mobilenavigation__header">
                    <button className="no-focusborder offside-button mobilenavigation__close-button" type="button"
                            onClick={() => this.setSidebarVisible(false)}><span
                        className="sprite sprite--cross">
                            <SVG src={crossIcon}/>

                        </span></button>
                </div>
                <div className="mobilenavigation__inner">
                    <div className="navigation home">
                        <ul className="navigation__list">
                            <li>
                                <NavLink
                                    to="/projekte"
                                    className={({ isActive, isPending }) =>
                                        isActive ? "active" : isPending ? "" : ""
                                    }
                                >
                                    Projekte
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/kontakte"
                                    className={({ isActive, isPending }) =>
                                        isActive ? "active" : isPending ? "" : ""
                                    }
                                >
                                    Kontakte
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/reports"
                                    className={({ isActive, isPending }) =>
                                        isActive ? "active" : isPending ? "" : ""
                                    }
                                >
                                    Reporting
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/weitere-karten"
                                    className={({ isActive, isPending }) =>
                                        isActive ? "active" : isPending ? "" : ""
                                    }
                                >
                                    Weitere Karten
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/hilfe"
                                    className={({ isActive, isPending }) =>
                                        isActive ? "active" : isPending ? "" : ""
                                    }
                                >
                                    Hilfe
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
